<div class="table-list--content absence-request-list">
  <filter-wrap-tile>
    <div class="status-tabs sub-title">
      {{ 'Absence Request' | translate }}
    </div>

    <div class="filter-right-wrap mx-0"></div>
  </filter-wrap-tile>

  <div class="wrapper" [class.list-no-items--wrapper]="!collection.items?.length">
    <list-v2 [fields]="sortFields" [items]="collection.items" [collection]="collection" (submitClick)="editAbsence($event)">
      <ng-template #checkboxField let-item="item">
        <div class="checkbox" *ngIf="!item.editMode">
          <label class="checkbox__label" (click)="handleSelect($event, item)">
            <input type="checkbox" [checked]="collection.selectedItems.has(item.id)" />
            <span class="checkbox__check"></span>
          </label>
        </div>
      </ng-template>

      <ng-template #logoField let-item="item">
        <div class="text-ellipsis">
          <logo [url]="item?.user?.avatars?.small_thumb_path"></logo>
        </div>
      </ng-template>

      <ng-template #idField let-item="item">
        <div class="text-ellipsis">{{ item?.user?.display_id }}</div>
      </ng-template>

      <ng-template #nameField let-item="item">
        <div class="text-ellipsis">{{ item?.user?.first_name }} {{ item?.user?.last_name }}</div>
      </ng-template>

      <ng-template #typeField let-item="item">
        <div class="text-ellipsis">{{ item?.absenceType ? item?.absenceType.name : ('Vacation' | translate) }}</div>
      </ng-template>

      <ng-template #periodField let-item="item">
        <div [matTooltip]="setPeriodTooltip(item) | translate" class="text-ellipsis">
          {{ item.from | formatDate }} - {{ item.to | formatDate }} ({{ item.working_days }}
          <ng-container *ngIf="item.working_days > 1; else dayWord">
            <span>{{ 'days' | translate }}</span> </ng-container
          >)
        </div>

        <ng-template #dayWord>
          <span>{{ 'day' | translate }}</span>
        </ng-template>
      </ng-template>

      <ng-template #optionsField let-item="item">
        <div class="action-controls">
          <button
            *ngIf="canUpdate(item)"
            (click)="changeStatus(item, requestStatuses.Approve)"
            [disabled]="(collection.loadingCrud$ | push).updating">
            <i class="icon icon-Save_ico option-icon option-icon-save"></i>
          </button>

          <button *ngIf="canDelete(item)" (click)="delete(item)">
            <i class="icon action-icon icon-Delete_ico" [matTooltip]="'Delete' | translate"></i>
          </button>
        </div>
      </ng-template>
    </list-v2>

    <app-pagination [collection]="collection"> </app-pagination>

    <actions-tile [collection]="collection" [actions]="actions" (canceledChanged)="closeActions($event)"> </actions-tile>

    <ng-container *ngIf="!collection.loading && collection.loaded && !collection.items?.length">
      <empty-items iconUrl="/assets/img/no-absences.svg" [entity]="'absences' | translate"></empty-items>
    </ng-container>
  </div>
</div>
